import { render } from "./userInfo.vue?vue&type=template&id=d89c84c8&scoped=true&ts=true"
import script from "./userInfo.vue?vue&type=script&lang=ts"
export * from "./userInfo.vue?vue&type=script&lang=ts"

import "./userInfo.vue?vue&type=style&index=0&id=d89c84c8&lang=scss&scoped=true"
import "./userInfo.vue?vue&type=style&index=1&id=d89c84c8&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89c84c8"]])

export default __exports__